export const driverListPageRouteName = "/master-data/driver";
export const addDriverPageRouteName = "/master-data/driver/add";
export const editDriverPageRouteName = (id?: string) => `/master-data/driver/edit/${id ?? ":id"}`;
export const draftDriverPageRouteName = "/master-data/driver/draft";
